import { FETCH_PROFILE } from '@/components/fakeDoor/constants';
import { getRequest } from '../authTokens/http_requests';

const ACKO_DRIVE_ENDPOINT = process.env.NEXT_PUBLIC_ACKO_DRIVE_API_IP;

class UserServices {
    async fetchUserProfile() {
        let data;
        const url = `${ACKO_DRIVE_ENDPOINT}/${FETCH_PROFILE}`;
        try {
            const response = await getRequest(url, true);
            if (
                response &&
                response.data &&
                response.data == 'RetailToken is missing in headers'
            ) {
                data = { error: true };
            } else {
                data = response.data;
            }
        } catch (error) {
            data = { error: true };
        }
        return data;
    }
}

export default new UserServices();
